import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Elements
import Label from '../elements/Label';
var SectionField = function SectionField(_ref) {
  var fieldId = _ref.fieldId,
    data = _ref.data;
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(data.type.toLowerCase()).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [!!data.label && _jsx(Label, {
      fieldId: fieldId,
      data: data
    }), !!data.description && _jsx("div", {
      className: "form-duuf-description",
      children: data.description
    })]
  });
};
export default SectionField;